import store from '../../store'
import XLSX from 'xlsx';
import ElementUI from 'element-ui';
const importf = (obj) => { //导入
    let wb; //读取完成的数据
    let rABS = false; //是否将文件读取为二进制字符串
    if (!obj.files) {
        return;
    }
    let f = obj.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
        const loading = ElementUI.Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        let data = e.target.result;
        if (rABS) {
            wb = XLSX.read(btoa(fixdata(data)), { //手动转化
                type: 'base64'
            });
        } else {
            wb = XLSX.read(data, {
                type: 'binary'
            });
        }
        let SheetNum = wb.SheetNames.length
        let SheetBox = []
        for (let i = 0; i < SheetNum; i++) {
            SheetBox.push(XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[i]]))
        }
        // console.log(SheetBox)
        let keys = []
        for (let key in SheetBox[0][0]) {
            // console.log(key)
            keys.push({ name: key, type: false })
        }
        store.commit('changeKeys', keys)
        store.commit('changeSheetBox', SheetBox)
        loading.close()
    };
    if (rABS) {
        reader.readAsArrayBuffer(f);
    } else {
        reader.readAsBinaryString(f);
    }
}

export { importf }


// WEBPACK FOOTER //
// ./src/components/util/index.js